/**
 * « Quoi de neuf » — journal des évolutions, écrit pour les utilisateurs.
 *
 * À compléter à chaque version, en tête de liste. Chaque point indique à qui
 * il s'adresse, pour que chacun ne voie que ce qui le concerne :
 *   tous         tout le monde
 *   encadrement  coachs, trésoriers et admins du club
 *   admin        admins du club
 *   editeur      l'éditeur d'Équipote seulement
 *
 * Règle : une correction de défaut est toujours « tous » — chacun doit savoir
 * qu'un problème qu'il a pu rencontrer est réglé.
 */
export const NOUVEAUTES = [
  { version: '3.24.0', points: [
    { pour: 'tous', icone: '⚑', texte: "Un message vous semble déplacé ? Ouvrez-le et touchez « Signaler ce message » : il est masqué pour vous, et l'équipe d'Équipote l'examine. Votre club ne sait pas qui l'a signalé." },
    { pour: 'tous', icone: '👤', texte: "« Supprimer mon compte » est désormais disponible dans « aide et contact », en bas de page." },
    { pour: 'editeur', icone: '🛡️', texte: "Console, onglet « Retours » : les messages signalés, avec leur contenu, à examiner sous 24 heures." },
  ]},
  { version: '3.23.0', points: [
    { pour: 'tous', icone: '📱', texte: "Préparation des applications iPhone et Android, bientôt sur l'App Store et Google Play : les notifications y arriveront directement, sans installation depuis le navigateur." },
    { pour: 'tous', icone: '🔒', texte: "Sécurité renforcée : seuls l'application et le site d'Équipote peuvent désormais échanger avec le serveur." },
  ]},
  { version: '3.22.3', points: [
    { pour: 'tous', icone: '🛠️', texte: "Améliorations et corrections mineures." },
  ]},
  { version: '3.22.2', points: [
    { pour: 'tous', icone: '💶', texte: "Correctif des caisses : les montants s'enregistrent au centime près — une dépense de 8,32 € n'est plus arrondie au demi-euro — et le serveur refuse désormais tout montant négatif ou invalide." },
  ]},
  { version: '3.22.1', points: [
    { pour: 'tous', icone: '📈', texte: "Correctif : les courbes des statistiques et la liste des matchs suivent désormais l'ordre chronologique, de la J1 à la dernière journée, même quand la saison s'étale sur plusieurs mois." },
  ]},
  { version: '3.22.0', points: [
    { pour: 'tous', icone: '🧭', texte: "Une visite de découverte accueille chacun à sa première connexion, selon son rôle : joueur, trésorier, coach ou direction du club. Elle aide aussi à activer les notifications. À revoir depuis « aide et contact »." },
  ]},
  { version: '3.21.3', points: [
    { pour: 'tous', icone: '📅', texte: "Matchs et entraînements sont désormais rangés en « À venir » — le prochain toujours en tête — puis « Passés », les plus anciens repliés derrière « Voir les plus anciens »." },
  ]},
  { version: '3.21.2', points: [
    { pour: 'encadrement', icone: '🧺', texte: "Maillots : le prochain est choisi parmi les joueurs présents au match, et la carte indique de quel match il s'agit. « Pas lui ? » permet de choisir un autre présent, et chaque ligne a son bouton « Il les prend »." },
  ]},
  { version: '3.21.1', points: [
    { pour: 'editeur', icone: '📅', texte: "L'essai gratuit passe de 15 jours à un mois pour les nouveaux clubs : le temps de faire tourner l'application en vrai, et de passer devant le bureau." },
  ]},
  { version: '3.21.0', points: [
    { pour: 'encadrement', icone: '📋', texte: "Coachs : sous chaque match et entraînement, « Copier pour WhatsApp » met la convocation en forme pour le groupe de l'équipe, avec le lien pour répondre. Sur téléphone, « Partager » l'envoie directement." },
    { pour: 'encadrement', icone: '🔔', texte: "« Relancer » prévient d'un clic les joueurs convoqués qui n'ont pas répondu, par notification et par email. Vous savez qui reste injoignable." },
  ]},
  { version: '3.20.1', points: [
    { pour: 'encadrement', icone: '🏟️', texte: "Gymnases : la liste reste commune au club, mais chaque équipe choisit désormais son propre gymnase par défaut, sans toucher à celui des autres." },
  ]},
  { version: '3.20.0', points: [
    { pour: 'tous', icone: '❓', texte: "Nouveau : « aide et contact », en bas de page. Les réponses aux questions fréquentes, et un formulaire pour signaler un problème avec l'application, ou poser une question à la direction et au coach de votre club." },
    { pour: 'tous', icone: '💡', texte: "Une idée pour Équipote ? Proposez-la depuis « bientôt dans Équipote » : les idées qui reviennent le plus rejoignent la liste des projets." },
    { pour: 'editeur', icone: '💬', texte: "Console : onglets « Retours » (problèmes signalés, avec leur contexte et leur capture d'écran ; idées) et « FAQ », modifiable sans nouvelle version." },
  ]},
  { version: '3.19.1', points: [
    { pour: 'tous', icone: '🎂', texte: "Les anniversaires s'affichent aussi en haut de vos convocations, le jour même : plus besoin d'avoir activé les notifications pour ne pas les manquer." },
  ]},
  { version: '3.19.0', points: [
    { pour: 'tous', icone: '🗺️', texte: "Nouveau : « bientôt dans Équipote », en bas de page. Découvrez les projets en préparation, et dites-nous ce qui vous intéresse : ça nous aide à choisir quoi faire en premier." },
    { pour: 'editeur', icone: '📊', texte: "Console, onglet « Bientôt » : gérez les projets annoncés et voyez combien de joueurs, coachs et dirigeants s'y intéressent, et dans combien de clubs." },
  ]},
  { version: '3.18.3', points: [
    { pour: 'encadrement', icone: '👆', texte: "Modifier un joueur, un gage ou un défi ouvre désormais le formulaire juste en dessous, sans remonter en haut de la page. Un second clic le referme." },
  ]},
  { version: '3.18.0', points: [
    { pour: 'tous', icone: '🧾', texte: "Nouveau : les Tâches. Table de marque, goûter, transport… vous voyez quand c'est votre tour, et vous êtes prévenu. Un empêchement ? « Je ne peux pas » : la tâche passe au suivant." },
    { pour: 'encadrement', icone: '⚖️', texte: "Coachs : créez les tâches de l'équipe, elles sont réparties automatiquement et équitablement. Une absence déclarée libère la tâche, et un tableau montre qui a fait quoi depuis le début de la saison." },
  ]},
  { version: '3.17.0', points: [
    { pour: 'admin', icone: '🔔', texte: "Abonnement annuel : un avis vous est envoyé un à deux mois avant sa reconduction, avec le prix de la saison suivante et la façon de ne pas la reconduire." },
    { pour: 'editeur', icone: '🧹', texte: "Essais non convertis : le club est averti, puis ses données sont supprimées trois mois après la fin de l'essai. Acceptation des CGV à la souscription, prête à être activée." },
  ]},
  { version: '3.16.0', points: [
    { pour: 'tous', icone: '📣', texte: "Nouveau : les Messages. Les informations de votre coach et de votre club arrivent ici, avec une notification — et un email pour les plus importantes. Une pastille signale les non-lus." },
    { pour: 'encadrement', icone: '✏️', texte: "Coachs : « Nouveau message » pour informer votre équipe, avec PDF et photos. Vous voyez qui l'a lu, et qui ne l'a pas encore ouvert." },
    { pour: 'admin', icone: '🏛️', texte: "Direction du club : écrivez à tout le club, à l'encadrement, ou aux équipes de votre choix." },
  ]},
  { version: '3.15.4', points: [
    { pour: 'admin', icone: '🧾', texte: "Souscrire l'abonnement : le numéro SIREN de l'association est demandé, pour une facture conforme à la facturation électronique." },
  ]},
  { version: '3.15.2', points: [
    { pour: 'admin', icone: '🏛️', texte: "Après l'ouverture d'un essai, la première connexion mène directement à « Mon club », pour créer ses équipes et inviter son encadrement." },
  ]},
  { version: '3.15.1', points: [
    { pour: 'editeur', icone: '🔄', texte: "Console : « Resynchroniser avec Kwixéo » remet à jour le contrat et les factures d'un club si une notification a manqué. La suppression d'un club vérifie elle-même l'état du contrat dans Kwixéo." },
  ]},
  { version: '3.15.0', points: [
    { pour: 'editeur', icone: '🗑️', texte: "Console : suppression définitive d'un club suspendu, après avoir retapé son nom. Bloquée tant qu'un contrat Kwixéo est actif ; un email de trace à chaque suppression." },
  ]},
  { version: '3.14.0', points: [
    { pour: 'admin', icone: '🧾', texte: "Passer à l'abonnement : la facture est désormais établie au nom officiel et à l'adresse de l'association, et envoyée automatiquement avec un lien de paiement par carte." },
    { pour: 'editeur', icone: '💶', texte: "Facturation Kwixéo : client et contrat créés automatiquement à chaque demande d'abonnement, abonnement prolongé dès que la facture est payée. Panneau de contrôle et essai dans le bac à sable dans la console." },
  ]},
  { version: '3.13.0', points: [
    { pour: 'encadrement', icone: '🧒', texte: "Équipes de jeunes : la caisse noire et la 3ème mi-temps sont désactivées par défaut. Le coach peut les activer, vierges, si l'équipe le souhaite vraiment." },
    { pour: 'encadrement', icone: '📋', texte: "Nouvelle équipe adulte : la caisse noire démarre avec un barème d'exemple, signalé comme tel jusqu'à ce que le trésorier l'adapte." },
  ]},
  { version: '3.12.2', points: [
    { pour: 'editeur', icone: '🔁', texte: "Console : « Consulter » ouvre bien les statistiques de l'équipe, au lieu de revenir à la console." },
  ]},
  { version: '3.12.1', points: [
    { pour: 'editeur', icone: '🎭', texte: "Console : le rôle de chaque compte se change directement dans la fiche du club — joueur, trésorier, coach ou administrateur du club." },
  ]},
  { version: '3.12.0', points: [
    { pour: 'tous', icone: '🔒', texte: "Les caisses appartiennent à l'équipe : seuls ses joueurs et son encadrement les voient. La direction du club n'y a pas accès, sauf si l'équipe le décide." },
    { pour: 'encadrement', icone: '💰', texte: "Trésorier ou coach : en bas des pages de caisses, choisissez ce que la direction du club en voit — rien, les totaux ou le détail, toujours en lecture seule." },
  ]},
  { version: '3.11.1', points: [
    { pour: 'encadrement', icone: '📎', texte: "Chaque nouveau compte reçoit un guide de démarrage en PDF : installer l'application sur iPhone et Android, et la prise en main. Il est aussi en ligne, sur app.equipote.fr/guide-equipote.pdf." },
  ]},
  { version: '3.11.0', points: [
    { pour: 'encadrement', icone: '📄', texte: "Import des feuilles : chaque match importé est listé par saison, avec son adversaire, sa date et sa feuille." },
    { pour: 'tous', icone: '📱', texte: "Sur téléphone, la barre du haut fait plus de place au nom du club." },
    { pour: 'editeur', icone: '🔎', texte: "Console : recherche des clubs, clubs suspendus rangés à part, et comptes de chaque club regroupés par équipe — avec leur dernière connexion et la validation des conditions." },
  ]},
  { version: '3.10.0', points: [
    { pour: 'admin', icone: '★', texte: "Offre fondateur : la saison à 150 € TTC au lieu de 250 €, garantie deux saisons, pour les dix premiers clubs abonnés." },
    { pour: 'admin', icone: '💶', texte: "Les tarifs sont désormais affichés TTC : 25 € par mois, ou 250 € la saison — deux mois offerts." },
    { pour: 'editeur', icone: '🗂️', texte: "Console : compteur de l'offre fondateur, badge sur les clubs concernés, et interrupteur pour accorder une place." },
  ]},
  { version: '3.9.0', points: [
    { pour: 'tous', icone: '✨', texte: "Un clic sur le numéro de version, en bas de page, affiche les dernières nouveautés." },
  ]},
  { version: '3.8.0', points: [
    { pour: 'tous', icone: '🚙', texte: "Covoiturage : choisis directement la voiture dans laquelle tu montes. Le conducteur est prévenu." },
    { pour: 'tous', icone: '🔔', texte: "Si ton conducteur se désiste, tu es prévenu et tu peux choisir une autre voiture." },
    { pour: 'encadrement', icone: '🧩', texte: "Le récapitulatif d'un match montre chaque voiture et ses passagers ; vous pouvez placer ou déplacer n'importe qui." },
  ]},
  { version: '3.7', points: [
    { pour: 'tous', icone: '✉️', texte: "Des emails entièrement redessinés, aux couleurs et au logo du club." },
    { pour: 'tous', icone: '🔑', texte: "« Mot de passe oublié » fonctionne pour tous les comptes, parents compris." },
    { pour: 'admin', icone: '🎟️', texte: "Pendant l'essai, le bouton « Passer à l'abonnement » envoie votre demande en un clic." },
    { pour: 'editeur', icone: '📝', texte: "Inscription en libre-service avec confirmation par email, et demandes d'abonnement dans la console." },
  ]},
  { version: '3.6', points: [
    { pour: 'admin', icone: '⏳', texte: "Période d'essai de 15 jours, avec un compte à rebours pour l'encadrement." },
  ]},
  { version: '3.5', points: [
    { pour: 'tous', icone: '🎂', texte: "Anniversaires : le jour J, l'appli te le souhaite et prévient l'équipe — jamais ton âge. Désactivable dans « Mes convocations »." },
    { pour: 'tous', icone: '✋', texte: "Absent ? Un clic suffit, plus besoin de te justifier." },
  ]},
  { version: '3.4', points: [
    { pour: 'tous', icone: '🔒', texte: "Protection des données : la notice est consultable à tout moment depuis le bas de page." },
    { pour: 'tous', icone: '👨‍👧', texte: "Pour les moins de 15 ans, le compte est rattaché à un parent, qui valide les conditions." },
    { pour: 'tous', icone: '👀', texte: "Les statistiques sont réservées aux membres connectés." },
    { pour: 'admin', icone: '🌐', texte: "Vous pouvez rendre vos statistiques publiques et partager un lien par équipe (Mon club → Équipes)." },
  ]},
  { version: '3.3', points: [
    { pour: 'admin', icone: '📅', texte: "Un bandeau vous prévient avant l'échéance de l'abonnement du club." },
  ]},
  { version: '3.2', points: [
    { pour: 'admin', icone: '🏛️', texte: "Mon club : créez vos équipes, ajoutez vos coachs et votre trésorier, rattachez chacun à ses équipes." },
  ]},
  { version: '3.1', points: [
    { pour: 'admin', icone: '🎨', texte: "L'application aux couleurs du club : deux couleurs et votre logo (Mon club → Apparence)." },
  ]},
  { version: '3.0', points: [
    { pour: 'encadrement', icone: '👥', texte: "Plusieurs équipes par club : changez d'équipe depuis la barre du haut." },
  ]},
  { version: '2.5', points: [
    { pour: 'tous', icone: '🔄', texte: "Plus besoin de réinstaller l'appli : un bandeau propose d'actualiser quand une mise à jour sort." },
  ]},
];

const NIVEAU = { joueur: 0, tresorier: 1, admin_3mt: 1, coach: 1, admin_club: 2, admin: 2, super_admin: 3 };
const SEUIL  = { tous: 0, encadrement: 1, admin: 2, editeur: 3 };

/** Versions et points visibles pour un rôle (visiteur non connecté : « tous »). */
export function nouveautesPour(role) {
  const n = NIVEAU[role] ?? 0;
  return NOUVEAUTES.map(v => ({ ...v, points: v.points.filter(p => n >= (SEUIL[p.pour] ?? 0)) }))
                   .filter(v => v.points.length);
}

/** Compare deux numéros de version : 3.10 > 3.9 > 3.8.0. */
export function versionPlusRecente(a, b) {
  const pa = String(a).split('.').map(Number), pb = String(b).split('.').map(Number);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d > 0;
  }
  return false;
}

const CLE_VUE = 'nouveautes-vues';
export const derniereVue = () => { try { return localStorage.getItem(CLE_VUE); } catch { return null; } };
export const marquerVues = v => { try { localStorage.setItem(CLE_VUE, v); } catch {} };

/** Y a-t-il, pour ce rôle, des nouveautés plus récentes que la dernière consultation ? */
export function aDesNouveautes(role) {
  const vue = derniereVue();
  // Jamais consulté : la pastille apparaît, pour que chacun découvre ce qui existe
  if (!vue) return nouveautesPour(role).length > 0;
  return nouveautesPour(role).some(v => versionPlusRecente(v.version, vue));
}
